<div
  mat-icon-button
  [matMenuTriggerFor]="userMenu"
  #userMenuTrigger="matMenuTrigger"
  class="d-flex align-items-center"
>
  <mat-icon
    aria-label="Profile. Click to switch to another account or logout from application."
    aria-hidden="false"
    style="font-size: 28px; width: 28px; height: 28px; margin-right: 4px"
  >
    account_circle
  </mat-icon>
  <mat-icon
    class="fs-16 mt-2"
    style="font-size: 28px; width: 28px; height: 28px"
  >
    keyboard_arrow_down
  </mat-icon>
</div>

<mat-menu #userMenu="matMenu" class="user-menu">
  <div class="profile-card">
    <div class="profile-header">
      <div class="avatar">
        <span>{{ initials() }}</span>
      </div>
    </div>
    <div class="profile-details">
      <h3>{{ user()?.name }}</h3>
      <p>{{ user()?.username }}</p>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon>power_settings_new</mat-icon>
      <span class="log-out">Log out</span>
    </button>
  </div>
</mat-menu>
